import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { LoteAgendamento } from "../../../../services/LoteAgendamento";
import { IImportarPlanilhaProps } from "../../../../types/loteAgendamento";

export const useImportarPlanilhaLote = () => {
  return useMutation({
    mutationFn: (data: IImportarPlanilhaProps) =>
      LoteAgendamento.importarPlanilha(data),
    onError: ({
      response: {
        data: { mensagem },
      },
    }: any) => {
      toast.error(mensagem);
    },
  });
};
